import { SearchProps } from '~components/form-fields/search';

import { selectLocations } from '~appointments/selectors/locations';
import { selectUserDepartments } from '~care-workers/selectors/userDepartments';
import { selectUserPayLevels } from '~care-workers/selectors/userPayLevels';
import { selectLookupUsers } from '~care-workers/selectors/users';
import { selectRegions } from '~lookups/selectors/regions';
import { selectLookupClients } from '~main/selectors/clients/clients';

const fields: SearchProps = {
  user_id: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'id',
    caption: 'Care Worker',
    placeholder: 'All',
    selectorOptions: selectLookupUsers,
  },
  region_id: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'region_id',
    caption: 'Region',
    placeholder: 'All',
    selectorOptions: selectRegions,
  },
  pay_level: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'pay_level_id',
    caption: 'Pay Level',
    placeholder: 'All',
    selectorOptions: selectUserPayLevels,
  },
  department: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'department_id',
    caption: 'Department',
    placeholder: 'All',
    selectorOptions: selectUserDepartments,
  },
  user_location: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'work_sites',
    caption: 'User Location',
    placeholder: 'All',
    selectorOptions: selectLocations,
  },
  appointment_location: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'filter_by[location_override_id][]',
    caption: 'Appointment Location',
    placeholder: 'All',
    selectorOptions: selectLocations,
  },
  clients_id: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'filter_by[client_id][]',
    caption: 'Client',
    placeholder: 'All',
    selectorOptions: selectLookupClients,
  },
  trip_location: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'filter_by[transport_id][]',
    caption: 'Pickup / Dropoff Location',
    placeholder: 'All',
    selectorOptions: selectLocations,
  },
};

export default fields;
